import React from "react";
import {InvoiceFpDataDisplay} from "./InvoiceFpDataDisplay";
import {useRenderableData} from "../common/hooks/useRenderableData";

export let CollapsibleInvoiceFpDataDisplay = (props) => {
    let renderableData = useRenderableData({
        showFpInvoice: true,
    })

    function toggleFpInvoiceDisplay() {
        renderableData.updateAndRender({showFpInvoice: !renderableData.showFpInvoice})
    }

    return (
        <div
            id={props.fpInvoiceDataAnchor}
            className={`invoice-fp-data ${renderableData.showFpInvoice ? 'show' : ''}`}
        >
            <div
                className="invoice-fp-data-header"
                onClick={toggleFpInvoiceDisplay}
            >
                <div className="invoice-fp-data-header-content">
                    <div className="invoice-fp-data-header-text">
                        Function Point Invoice
                    </div>
                    <img
                        src="/static/images/chevron-down-moss-green.svg"
                        className="invoice-fp-data-header-icon"
                    />
                </div>
            </div>
            <div className="invoice-fp-data-body">
                <InvoiceFpDataDisplay fpInvoice={props.fpInvoice}/>
            </div>
        </div>
    )
}
